import $ from 'jquery';
import FormFieldView from 'app/generic/form/views/FormField';
import Slideshow from 'picnic/Slideshow';


var
	ERRORMESSAGE_CLASSNAME = 'errormessage',
	ERROR_CLASSNAME = 'error'
;


class View extends FormFieldView {

	render() {
		super.render();

		this._renderStepSlideshow();

		return this;
	}

	events() {
		return {
			'submit form': this._onSubmit
		};
	}

	_renderStepSlideshow() {
		this._slideshow = new Slideshow({
			el: this.$el.find('.slideshow'),
			context: this.context,
			settings: {
				fade: true
			}
		}).render();
	}

	_renderError(error_list) {
		$.each(error_list, (key, text) => {
			this.$el.find('[name=' + key + ']')
				.addClass(ERROR_CLASSNAME)
				.parent().append($('<span class="' + ERRORMESSAGE_CLASSNAME + '"></span>')
				.text(text)
			);
		});

		this._slideshow.resize();
	}

	_onSubmit(event) {
		event.preventDefault();

		var
			$form = this.$el.find('form'),
			action = $form.attr('action'),
			data = $form.serialize()
		;

		this.$el.find('input, textarea, select').removeClass(ERROR_CLASSNAME).nextAll('span').remove();

		$.post(
			action,
			data,
			data => {
				if (data.success) {
					this._slideshow.next();
				} else {
					this._renderError(data.error_list);
				}
			}
		);
	}

}

export default View;
